import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'This site has no assigned devices',
  description: 'Devices can be reassigned here from other sites.',
})
